import { AccessTime, CancelOutlined, CheckCircleOutline, ErrorOutline, HourglassEmptyOutlined } from '@mui/icons-material'
import { Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AmendmentStateChip } from '@omnea-app/fe-legacy/components/shared/amendments/AmendmentStateChip'
import { useRequestLdFlags } from '@omnea-app/fe-requests/launch-darkly'
import { assertNever } from '@omnea-app/packages/universal/type-guards/assertNever'
import { TaskStatusEnum } from '@omnea-app/requests/requestsFrontendClient'

interface Props {
  status: TaskStatusEnum
}

export const TaskStatusChip = ({ status }: Props) => {
  const { t } = useTranslation('tasks')
  const { RELEASE_AMENDMENT_REQUESTS_REVAMP } = useRequestLdFlags()

  switch (status) {
    case TaskStatusEnum.NOT_STARTED:
      return <Chip label={t('table.not-started')} color="warning" icon={<HourglassEmptyOutlined />} />
    case TaskStatusEnum.IN_PROGRESS:
      return <Chip label={t('table.in-progress')} color="info" icon={<AccessTime />} />
    case TaskStatusEnum.REJECTED:
      return <Chip label={t('table.rejected')} color="error" icon={<CancelOutlined />} />
    case TaskStatusEnum.COMPLETE:
      return <Chip label={t('table.completed')} color="success" icon={<CheckCircleOutline />} />
    case TaskStatusEnum.OVERDUE:
      return <Chip label={t('table.overdue')} color="error" icon={<ErrorOutline />} />
    case TaskStatusEnum.AMENDMENT_REQUESTED: {
      if (!RELEASE_AMENDMENT_REQUESTS_REVAMP) {
        return <Chip label={t('table.awaiting-amendment')} color="neutral" icon={<ErrorOutline />} />
      }
      return (
        <AmendmentStateChip
          state="awaiting-change"
          label={t('table.awaiting-change')}
          tooltipLabel={t('table.awaiting-change-tooltip')}
        />
      )
    }
    case TaskStatusEnum.AMENDMENT_REQUIRED: {
      if (!RELEASE_AMENDMENT_REQUESTS_REVAMP) {
        return <Chip label={t('table.amendment-required')} color="neutral" icon={<ErrorOutline />} />
      }
      return (
        <AmendmentStateChip
          state="change-required"
          label={t('table.change-required')}
          tooltipLabel={t('table.change-required-tooltip')}
        />
      )
    }
    default:
      return assertNever(status)
  }
}
